// Media Storage Tour
// Uploading, organizing and reusing images, video and files
// Selector policy: step 1 pins to the LIVE-VERIFIED sidebar id (#sb_app-media); the teaching steps are
// deliberate centered cards — no guessed element selectors (a wrong spotlight is worse than none).

export const mediaStorageTour = {
  id: 'media-storage',
  name: 'Media Storage Tour',
  displayName: 'Organize Your Media Library',
  description: 'Uploading, organizing and reusing images, video and files',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: {
    animate: true,
    overlayOpacity: 0.75,
    smoothScroll: true,
    allowClose: true,
    showProgress: true
  },

  steps: [
    {
      element: '#sb_app-media',
      popover: {
        title: "🖼️ Welcome to Media Storage",
        description: `
          Every image, video, and file your funnels, emails, and courses use lives here — one library instead of scattered uploads.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "⬆️ Upload Once, Use Everywhere",
        description: `
          Upload a logo, product photo, or video **once**, then reuse it across funnels, emails, social posts, and courses. Update it here and it updates everywhere it is referenced.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📁 Folders Keep It Sane",
        description: `
          Media piles up fast. Use **folders** — by client, campaign, or asset type — so nobody hunts for the right logo six months from now.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔗 Direct File Links",
        description: `
          Every file has a shareable **URL**. Handy for embedding somewhere custom, or handing a client a download without email attachments.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📏 Watch Your File Sizes",
        description: `
          Big images and videos slow pages down. Compress before uploading — page speed is a conversion issue, not just a technical one.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your Library Is Tidy",
        description: `
          You can now:

✅ Upload once and reuse everywhere
✅ Organize with folders
✅ Grab direct links
✅ Keep files fast and light

**Next:** create folders for your brand assets and upload your logo set.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
